import React from 'react';
import { Box, Container } from '@mui/material';
import classNames from 'classnames';

import styles from './site-components/site.module.css';

const ReachExtension = () => {
  return (
    <div>
      <Container maxWidth="xl" className={classNames(styles.container)}>
        <div className={classNames(styles.reHeaderGrad, styles.headerOffset)}>
          <div className={styles.centerBlock}>
            <h1 className={classNames(styles.header, styles.headerSmallerWidth)}>
              Extend your reach, increase your inventory.
            </h1>
            <div className={classNames(styles.description, styles.narrow)}>
              Leverage our VAST 4.0 output to quickly integrate Transmit within your ad server.
            </div>
          </div>

          <div className={classNames(styles.reHeader, styles.xHidden)}>
            <div className={classNames(styles.reHeaderGrid)}>
              <div className={classNames(styles.reHeaderImg, styles.reHeaderOffset, styles.reHeader1)} />
              <div className={classNames(styles.reHeaderImg, styles.reHeaderOffset, styles.reHeader2)} />
              <div className={classNames(styles.reHeaderImg, styles.reHeaderOffset, styles.reHeader3)} />
              <div className={classNames(styles.reHeaderImg, styles.reHeaderOffset, styles.reHeader4)} />
              <div className={classNames(styles.reHeaderBlank)} />
              <div className={classNames(styles.reHeaderImg, styles.reHeader1)} />
              <div className={classNames(styles.reHeaderImg, styles.reHeader5)} />
              <div className={classNames(styles.reHeaderImg, styles.reHeader6)} />
              <div className={classNames(styles.reHeaderImg, styles.reHeader1)} />
              <div className={classNames(styles.reHeaderImg, styles.reHeader6)} />
              <div className={classNames(styles.reHeaderImg, styles.reHeaderOffset, styles.reHeader2)} />
              <div className={classNames(styles.reHeaderImg, styles.reHeaderOffset, styles.reHeader7)} />
              <div className={classNames(styles.reHeaderImg, styles.reHeaderOffset, styles.reHeader8)} />
              <div className={classNames(styles.reHeaderImg, styles.reHeaderOffset, styles.reHeader4)} />
            </div>
          </div>
        </div>

        <div className={classNames(styles.centerBlock, styles.mt12)}>
          <h2 className={styles.tagLineHeading}>Increase your supply.</h2>
          <Box className={classNames(styles.description, styles.medium)}>
            Maximize your content&apos;s monetization potential while boosting awareness.
          </Box>
        </div>

        <div className={classNames(styles.featureGrid, styles.mt4, styles.section)}>
          <div className={classNames(styles.featureBox, styles.reBuild, styles.gridTwoCol, styles.relative)}>
            <div className={classNames(styles.reBuildSpacer)} />
            <div className={styles.featureTitle}>Use content to build creatives</div>
            <div>
              Create captivating commercial templates specifically crafted to generate new inventory pairing content
              with ads.
            </div>
          </div>
          <div className={classNames(styles.featureBox, styles.reVast)}>
            <div className={styles.featureTitle}>Output Vast 4.0</div>
            <div>
              VAST-compliant tags for seamless implementation on your owned & operated inventory and in the open
              marketplace.
            </div>
            <div className={classNames(styles.reVastSpacer)} />
          </div>
          <div className={classNames(styles.featureBox, styles.reFormats)}>
            <div className={styles.featureTitle}>Support multiple formats</div>
            <div>Configure templates to render in variety of formats.</div>
            <div className={classNames(styles.reFormatsSpacer)} />
          </div>
        </div>

        <div className={classNames(styles.centerBlock, styles.mt12)}>
          <h2 className={styles.tagLineHeading}>Promote your content.</h2>
          <Box className={classNames(styles.description, styles.medium)}>
            Merge your content and brand advertisments to create unique and compelling monetization opportunities.
          </Box>
        </div>

        <div className={classNames(styles.featureGrid, styles.mt4, styles.section, styles.mb6)}>
          <div className={classNames(styles.featureBox, styles.reKeyPlays)}>
            <div className={styles.featureTitle}>Feature key plays</div>
            <div>Combine game highlights with brand advertisments to build promotional creatives.</div>
            <div className={classNames(styles.reKeyPlaysSpacer)} />
          </div>
          <div className={classNames(styles.featureBox, styles.featureBoxBlack, styles.reSportsMoments)}>
            <div className={classNames(styles.featureTitle, styles.white)}>Drive increased viewership</div>
            <div className={classNames(styles.white)}>
              Reach Extension creates more inventory for your content and alerts targeted viewers who may be watching
              different programming.
            </div>
            <div className={classNames(styles.reSportsMomentsSpacer)} />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ReachExtension;
